<!-- src/App.vue -->
<template>
  <div id="app">
    <div class="main">
      <Header />
      <ChatDisplay />
      <ChatInputText v-if="displayChat" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue';
import { useQuestionStore } from './store/questionStore';
import Header from './components/Header.vue';
import ChatDisplay from './components/ChatDisplay.vue';
import ChatInputText from './components/ChatInputText.vue';

export default defineComponent({
  name: 'Answers.lbbd.gov.uk',
  setup() {
    const questionStore = useQuestionStore();
    const displayChat = computed(
      () => questionStore.getConversations.length > 0
    );

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get('s');
      const view = urlParams.get('view') || 'standard';

      if (searchQuery) {
        questionStore.fetchAnswer(searchQuery, undefined, view);
      }
    });

    return { displayChat };
  },
  components: {
    Header,
    ChatDisplay,
    ChatInputText
  }
});
</script>

<style>
body {
  margin: 14px;
  background-color: white;
  font-family: 'Source Sans Pro', Arial, sans-serif;
}

@media (max-width: 500px) {
  body {
    margin: 16px;
  }
}

.main {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  max-width: 900px;
  margin: 0 auto;
  line-height: 26px;
}

a {
  text-decoration: underline;
  color: #007bff;
}

a.visited {
  color: inherit;
}
</style>
